import MaterialCommunityIcons from "@react-native-vector-icons/material-design-icons/static";
import type { LevelIconName } from "../../icon";
import {
	customLevelIcons,
	isCustomLevelIconName,
} from "../../icons/custom-level-icons";

type Props = {
	name: LevelIconName;
	size?: number;
	color?: string;
};

export const LevelIcon = ({ name, size, color }: Props) => {
	if (isCustomLevelIconName(name)) {
		const CustomIcon = customLevelIcons[name];
		return <CustomIcon size={size} color={color} />;
	}

	return <MaterialCommunityIcons name={name} size={size} color={color} />;
};
